import { useMemo } from "react";

import useTranslation from "@hooks/use_translation";
import type {
  DatePostedFilter,
  EmploymentTypeFilter,
  FilterOption,
  SalaryFilter,
  WorkTypeFilter,
} from "@/types/job_search/filters.ts";

export const useDatePostedOptions = (): FilterOption<DatePostedFilter>[] => {
  const { t } = useTranslation("jobSearch");

  return useMemo(
    () => [
      { label: t("datePostedOptions.within1Day"), value: "past_day" },
      { label: t("datePostedOptions.within5Days"), value: "past_five_days" },
      { label: t("datePostedOptions.within10Days"), value: "past_ten_days" },
      { label: t("datePostedOptions.within30Days"), value: "past_thirty_days" },
    ],
    [],
  );
};

export const useSalaryOptions = (): FilterOption<SalaryFilter>[] => {
  const { t } = useTranslation("jobSearch");

  return useMemo(
    () => [
      { label: t("salaryOptions.lessThan40k"), value: "less_than_40k" },
      { label: t("salaryOptions.moreThan40k"), value: "more_than_40k" },
      { label: t("salaryOptions.moreThan60k"), value: "more_than_60k" },
      { label: t("salaryOptions.moreThan80k"), value: "more_than_80k" },
      { label: t("salaryOptions.moreThan100k"), value: "more_than_100k" },
      { label: t("salaryOptions.moreThan120k"), value: "more_than_120k" },
      { label: t("salaryOptions.moreThan140k"), value: "more_than_140k" },
      { label: t("salaryOptions.moreThan160k"), value: "more_than_160k" },
      { label: t("salaryOptions.moreThan180k"), value: "more_than_180k" },
      { label: t("salaryOptions.moreThan200k"), value: "more_than_200k" },
    ],
    [],
  );
};

export const useWorkTypeOptions = (): FilterOption<WorkTypeFilter>[] => {
  const { t } = useTranslation("jobSearch");

  return useMemo(
    () => [
      { label: t("workTypeOptions.remote"), value: "remote" },
      { label: t("workTypeOptions.hybrid"), value: "hybrid" },
      { label: t("workTypeOptions.inPerson"), value: "in_person" },
    ],
    [],
  );
};

export const useEmploymentTypeOptions = (): FilterOption<EmploymentTypeFilter>[] => {
  const { t } = useTranslation("jobSearch");

  return useMemo(
    () => [
      { label: t("employmentTypeOptions.fullTime"), value: "full_time" },
      { label: t("employmentTypeOptions.partTime"), value: "part_time" },
      { label: t("employmentTypeOptions.contract"), value: "contract" },
      { label: t("employmentTypeOptions.temporary"), value: "temporary" },
    ],
    [],
  );
};
